import * as Dialog from '@radix-ui/react-dialog';
import '@/app/styles.scss';

interface ModalProps {
    open?: boolean;
    onClose?: () => void;
    alert?: boolean; // true일 경우 alert 모달 (예: 취소/확인 버튼 구성)
    title?: string;
    description?: React.ReactNode;
    children?: React.ReactNode;
    onConfirm?: () => void;
    onConfirmText?: React.ReactNode;
    onCancel?: () => void;
    onCancelText?: React.ReactNode;
    overlay?: boolean; // 모달 배경 활성화
    noButton?: boolean; // 버튼이 아예 필요없는 경우
    isCustom?: boolean; // 커스텀 모달 사용시 true
    containerClass?: string;
    descriptionClass?: string;
}

export const Modal = ({
    open,
    alert = false,
    title,
    description,
    children,
    onConfirm,
    onConfirmText,
    onCancel,
    onCancelText,
    onClose,
    overlay = true,
    noButton = false,
    isCustom = false,
    containerClass = 'pop_wrap choice_guide_pop',
    descriptionClass,
}: ModalProps & Dialog.DialogProps) => {
    return (
        <Dialog.Root open={open} onOpenChange={onClose}>
            <Dialog.Portal>
                {overlay && <Dialog.Overlay className="DialogOverlay" />}
                <Dialog.Title>{title + '팝업'}</Dialog.Title>
                <Dialog.Content className="DialogContent">
                    <div className="ki-dim ttukttak" style={!overlay ? { background: 'none' } : {}}>
                        <div className="pos-center">
                            {isCustom ? (
                                <>
                                    {children}
                                    {/* 커스텀 모달에서도 onConfirm이 제공되면 확인 버튼을 추가 */}
                                    {!noButton && onConfirm && (
                                        <div className="bt_wrap cont-mt2">
                                            <Dialog.Close asChild onClick={onConfirm}>
                                                <button className="btn btn-default blue">
                                                    {onConfirmText ?? '확인'}
                                                </button>
                                            </Dialog.Close>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className={containerClass}>
                                    <div className="modal_header">
                                        <div className="title">{title}</div>
                                    </div>
                                    <div className="pop_contents choice_guide_popcont">
                                        <div className="base-box box-type">
                                            <div className="form-label size-type1 blind">
                                                {/* 시각장애인 접근성을 위한 레이블 (화면에 보이지 않음) */}
                                                <div className="form-label size-type1 blind">
                                                    {title}
                                                </div>
                                            </div>
                                            <p className={descriptionClass}>{description}</p>
                                        </div>
                                        {children}
                                        {!noButton && (
                                            <div className="bt_wrap cont-mt2">
                                                {alert && (
                                                    <Dialog.Close onClick={onCancel}>
                                                        <span className="btn btn-default line_gray1">
                                                            {onCancelText ?? '취소'}
                                                        </span>
                                                    </Dialog.Close>
                                                )}
                                                <Dialog.Close onClick={onConfirm}>
                                                    <span className="btn btn-default blue">
                                                        {onConfirmText ?? '확인'}
                                                    </span>
                                                </Dialog.Close>
                                            </div>
                                        )}
                                    </div>
                                    <Dialog.Close>
                                        <span className="btn-x btn-x-white">
                                            <span className="sr-only">팝업 닫기</span>
                                        </span>
                                    </Dialog.Close>
                                </div>
                            )}
                        </div>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
